// extracted by mini-css-extract-plugin
export default {"listItem":"AllSearchItem_listItem__DrbHU","linkpara1":"AllSearchItem_linkpara1__O7uaF","linkpara2":"AllSearchItem_linkpara2__1wePg"};